import { useMutation, useQueryClient } from "@tanstack/react-query";
import { startSearch } from "../api/projects";

export function useStartSearch(projectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => startSearch(projectId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["project", projectId] });
    },
  });
}
